module.exports = {"id":"186132","name":"Danny Drinkwater","rating":"80","photo":"./data/images/photos/0/186132.png","club":{"name":"Chelsea","logo":"./data/images/clubs/Chelsea.png"},"positions":["MC"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/DannyDrinkwater0.json
// module id = 960
// module chunks = 0